// extracted by mini-css-extract-plugin
module.exports = {"heading":"AdminSchoolUpload_heading__qHCyT","column":"AdminSchoolUpload_column__3VWaf"};